import cloneDeep from 'lodash/cloneDeep';
import type { BlockerModel, BlockerState, BlockerType, CoinBlockerState } from '../../types';

let instanceIndex = 0;

export class CoinBlockerModel implements BlockerModel {
  // eslint-disable-next-line no-plusplus
  public readonly id = `coin_${instanceIndex++}`;

  public readonly destructible = false;

  public readonly underTile = false;

  private readonly state: CoinBlockerState;

  constructor(state: CoinBlockerState) {
    this.state = cloneDeep(state);
  }

  public getType(): BlockerType {
    return this.state.type;
  }

  public getPrice(): number {
    return this.state.price;
  }

  public setPrice(price: number): void {
    this.state.price = price;
  }

  public exportState(): BlockerState {
    return this.state;
  }
}
